__webpack_require__.p = "https://smart-tv.pinkfong.com/";